$(document).ready(function(){
  accordions();
});

  function accordions() {
    /** Accordion */
    $('.accordion-button').click(function() {
      var ariaLabel = $(this).attr('aria-label');

      $(this).toggleClass('active');
      $(this).toggleClass('expanded');
      $('#accordion-' + jQuery(this).attr('data-attr')).slideToggle();
      $('.icon', jQuery(this)).toggleClass('active');

      // if it's open
      if ( $(this).hasClass('expanded') ) {
        $(this).attr('aria-label', ariaLabel.replace('Expand and show','Collapse and hide'));
        $(this).parents('.accordion').attr('aria-expanded', true);
      }
      // if it's closed
      else {
        $(this).attr('aria-label', ariaLabel.replace('Collapse and hide','Expand and show'));
        $(this).parents('.accordion').attr('aria-expanded', false);
      }

      // if all accordions are expanded, change the text of the "Expand All" button to "Collapse All"
        if ( $(this).parents('.block--accordion').find('.accordion-button ').length == $(this).parents('.block--accordion').find('.expanded').length ) {
          $(this).parents('.block--accordion').find('.accordion__expandall').addClass('open').find('span').html('Collapse All');
        } else {
          $(this).parents('.block--accordion').find('.accordion__expandall').removeClass('open').find('span').html('Expand All');
        }

    });

    // Expand All / Collapse All functionality
    $('.accordion__expandall').on('click', function(e) {
      e.preventDefault();

      var $accordionGroup = $(this).parents('.block--accordion');

      // if it reads Expand All
      if ( $(this).find('span').html() == 'Expand All') {

        $(this).addClass('open');
        $(this).find('span').html('Collapse All');

        $accordionGroup.find('.accordion-button').each(function() {
          var ariaLabel = $(this).attr('aria-label');

          // if an accordion is collapsed, open it
          if ( !$(this).hasClass('expanded') ) {
            $(this).addClass('expanded');
            $(this).attr('aria-label', ariaLabel.replace('Expand and show','Collapse and hide'));
            $(this).next('.accordion-content').slideDown(500);
            $(this).parents('.accordion-item').attr('aria-expanded', true);
          }
        });
      }
      // if it reads Collapse All
      else {
        $(this).removeClass('open');
        $(this).find('span').html('Expand All');
        $accordionGroup.find('.accordion-button').removeClass('expanded');
        $accordionGroup.find('.accordion-content').slideUp(500);
        $accordionGroup.find('.accordion-item').attr('aria-expanded', false);

        $accordionGroup.find('.accordion-button').each(function() {
          var ariaLabel = $(this).attr('aria-label');
          $(this).attr('aria-label', ariaLabel.replace('Collapse and hide','Expand and show'));
        });
      }
    });
  }